import { injectable } from 'tsyringe';

// -------------------------------------------------------------
@injectable()
export class OWWrapper {
  // -------------------------------------------------------------
  public getVersion() {
    return overwolf.version;
  }
}
